



const SET_ERROR = 'error/SET_ERROR';
const CLEAR_ERROR = 'error/CLEAR_ERROR';
const SET_UPDATE_NOTE_ERROR = 'error/SET_UPDATE_NOTE_ERROR';
const CLEAR_UPDATE_ERROR = 'error/CLEAR_UPDATE_ERROR';



export {
  SET_ERROR,
  CLEAR_ERROR,
  SET_UPDATE_NOTE_ERROR,
  CLEAR_UPDATE_ERROR,


}
